import { BASE_URL } from "../configs";
import { getAccessToken } from "../helpers/auth/token";
import { getQueryParamsString } from "../lib/utils";
import axiosInstance from "./axios"

export async function getProject(projectId) {
  let url = `${BASE_URL}/api/project/${projectId}`;

  const res = await axiosInstance.get(url)
  return res.data.Data;
}

export async function getProjects({ q, page, perPage, clientId, status, showArchived = false }) {
  let url = `${BASE_URL}/api/project?`;
  url += getQueryParamsString({ q, page, perPage, clientId, status, showArchived })

  const res = await axiosInstance.get(url)
  return res.data.Data;
}

export async function createProject(project) {
  let url = `${BASE_URL}/api/project`;

  const res = await axiosInstance.post(url, project)
  return res.data.Data;
}

export async function updateProject(project) {
  let url = `${BASE_URL}/api/project`;

  const res = await axiosInstance.put(url, project)
  return res.data.Data;
}


export async function deleteProject(projectId) {
  let url = `${BASE_URL}/api/project/${projectId}`;

  const res = await axiosInstance.delete(url)
  return res.data.Data;
}

export async function archiveProject(projectId) {
  let url = `${BASE_URL}/api/project/archive/${projectId}`;

  const res = await axiosInstance.post(url)
  return res.data.Data;
}

export async function unArchiveProject(projectId) {
  let url = `${BASE_URL}/api/project/unarchive/${projectId}`;

  const res = await axiosInstance.post(url)
  return res.data.Data;
}